import React from 'react';
import { useDispatch } from 'react-redux';
import {
  BsBarChartLine,
  BsPeopleFill,
  BsGraphUpArrow,
  BsShieldCheck,
  BsLightningChargeFill,
  BsBoxArrowLeft,
} from 'react-icons/bs';
import styles from '../Onboarding.module.scss';
import AppLogo from '@/assets/img/brand/logo-transparent-blue.png';
import { onboardingSteps } from '../Onboarding.constants';
import { authActionTypes } from '@/store/Auth/Auth.actionTypes';

const BAR_HEIGHTS = [30, 50, 72, 46, 62, 82, 55];
const ACCENT_BAR_INDEX = 5;

const NAV_ITEMS = [false, true, false, false, false];

const FEATURES = [
  {
    icon: <BsBarChartLine size={16} color="#039855" />,
    colorClass: styles.featureIconGreen,
    title: 'Track productivity',
    desc: 'Monitor activities and improve performance',
  },
  {
    icon: <BsPeopleFill size={16} color="#3363F5" />,
    colorClass: styles.featureIconBlue,
    title: 'Manage attendance',
    desc: 'Real-time attendance and timesheets',
  },
  {
    icon: <BsGraphUpArrow size={16} color="#6938EF" />,
    colorClass: styles.featureIconPurple,
    title: 'Analyze workforce',
    desc: 'Powerful reports and actionable insights',
  },
  {
    icon: <BsShieldCheck size={16} color="#DC6803" />,
    colorClass: styles.featureIconYellow,
    title: 'Secure & compliant',
    desc: 'Enterprise-grade security for your data',
  },
];

export const OnboardingSidebar = ({ currentStep }) => {
  const dispatch = useDispatch();
  const totalSteps = onboardingSteps.length;

  const handleLogout = () => {
    localStorage.setItem('teamData', []);
    localStorage.setItem('Team', []);
    dispatch({ type: authActionTypes.LOGOUT_ACTIVE_ACCOUNT });
  };

  return (
    <aside className={styles.sidebar}>
      {/* Brand */}
      <div className={styles.sidebarBrand}>
        <img src={AppLogo} alt="Prodaff" className={styles.sidebarBrandLogo} />
        {/* <div className={styles.sidebarBrandText}>
          <span className={styles.sidebarBrandName}>Prodaff</span>
          <span className={styles.sidebarBrandTagline}>
            Employee Monitoring & Analytics
          </span>
        </div> */}
      </div>

      {/* Step badge */}
      <span className={styles.sidebarStepBadge}>
        Step {currentStep} of {totalSteps}
      </span>

      {/* Hero */}
      <div className={styles.sidebarHero}>
        <h2 className={styles.sidebarHeroHeading}>
          {"Let's set up"} <br />
          {'your '}
          <span className={styles.sidebarHeroAccent}>workspace</span>
        </h2>
        <p className={styles.sidebarHeroBody}>
          Add your company details to personalize your experience and get your
          team up and running in minutes.
        </p>
      </div>

      {/* Features */}
      <div className={styles.sidebarFeatures}>
        {FEATURES.map((feat) => (
          <div key={feat.title} className={styles.featureItem}>
            <div className={`${styles.featureIcon} ${feat.colorClass}`}>
              {feat.icon}
            </div>
            <div className={styles.featureText}>
              <span className={styles.featureTitle}>{feat.title}</span>
              <span className={styles.featureDesc}>{feat.desc}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Dashboard illustration */}
      <div className={styles.sidebarIllustration}>
        <div className={styles.sidebarIllustrationBlob} aria-hidden="true" />
        <div className={styles.dashMockCard}>
          <div className={styles.dashMockLayout}>
            {/* Dark sidebar */}
            <div className={styles.dashMockNav} aria-hidden="true">
              {NAV_ITEMS.map((isActive, i) => (
                <div
                  key={i}
                  className={
                    isActive
                      ? `${styles.dashMockNavItem} ${styles.dashMockNavItemActive}`
                      : styles.dashMockNavItem
                  }
                />
              ))}
            </div>
            {/* Content */}
            <div className={styles.dashMockBody} aria-hidden="true">
              <p className={styles.dashMockTitle}>Overview</p>
              <div className={styles.dashMockStats}>
                <div className={styles.dashMockStat}>
                  <span className={styles.dashMockStatLabel}>
                    Total Employees
                  </span>
                  <span className={styles.dashMockStatValue}>128</span>
                </div>
                <div className={styles.dashMockStat}>
                  <span className={styles.dashMockStatLabel}>
                    Present Today
                  </span>
                  <span className={styles.dashMockStatValue}>96</span>
                </div>
                <div className={styles.dashMockStat}>
                  <span className={styles.dashMockStatLabel}>Productivity</span>
                  <span className={styles.dashMockStatValue}>78%</span>
                </div>
              </div>
              <div className={styles.dashMockCharts}>
                <div className={styles.dashMockBars}>
                  {BAR_HEIGHTS.map((h, i) => (
                    <div
                      key={i}
                      className={
                        i === ACCENT_BAR_INDEX
                          ? `${styles.dashMockBar} ${styles.dashMockBarAccent}`
                          : styles.dashMockBar
                      }
                      style={{ height: `${h}%` }}
                    />
                  ))}
                </div>
                <div className={styles.dashMockDonut} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Setup-time badge */}
      <div className={styles.sidebarSetupBadge}>
        <BsLightningChargeFill size={14} color="#F79009" />
        <span>
          Setup takes less than{' '}
          <span className={styles.sidebarSetupBadgeAccent}>2 minutes</span>
        </span>
      </div>

      {/* Logout */}
      <button
        type="button"
        className={styles.sidebarLogoutBtn}
        onClick={handleLogout}
      >
        <BsBoxArrowLeft size={13} />
        Sign out
      </button>
    </aside>
  );
};
